<template>
  <div class="video">
    <category
      style="height: 2.5rem"
      :list="itemList"
      :current="contentParams"
      @changeCurrent="changeParams"
    />
    <div class="infinite-list-wrapper" style="overflow: auto">
      <ul
        class="categoryContent"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
        :style="{ height: `${contentHeight}rem` }"
      >
        <div style="margin: 0px 10px">
          <el-carousel height="105px" indicator-position="none">
            <el-carousel-item
              v-for="(item, key) in advertisementsList"
              :key="key"
            >
              <img
                @click="gotoURL(item.link)"
                :src="item.url"
                style="width: 100%; border-radius: 5px"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-if="labelList.length > 0" class="tagDiv">
          标签:
          <span
            class="tagLabel"
            v-for="(item, key) in labelList"
            :key="key"
            @click="handleTopic(item)"
          >
            {{ item }}
          </span>
        </div>
        <li
          class="categoryDiv"
          v-for="(item, key) in contentInfoList"
          :key="key"
          @click="handleDetail(item.id, InfoObject.code)"
        >
          <!-- <div class="title">{{ item.title }}</div> -->
          <div>
            <img
              :src="getImageURL(item.cover)"
              :style="{
                width: '140px',
                borderRadius: '5px',
              }"
            />
          </div>
          <div
            style="
              display: flex;
              margin-left: 5px;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div>{{ item.title }}</div>
            <div>
              <div style="color: #999999; font-size: 12px">
                {{ item.authorName }}
              </div>
              <div style="color: #999999; font-size: 12px">
                {{ item.playNumber | formatReadNumber }} 观看
              </div>
            </div>
          </div>
        </li>
      </ul>
      <!-- <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>-->
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
import category from "@/components/category";
export default {
  components: {
    category,
  },
  created() {},
  mounted() {
    this.getInfoClass();
    this.contentHeight = document.documentElement.clientHeight / 16 - 9;
    this.screenWidth = document.body.clientWidth;
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      screenWidth: 0,
      contentHeight: 0,
      InfoObject: {},
      itemList: [],
      contentInfoList: [],
      contentInfoListTotal: 0,
      currentContentId: "",
      advertisementsList: {},
      labelList: [],
      contentParams: {
        categoryId: "",
        page: 1,
        size: 10,
      },
      loading: false,
    };
  },
  filters: {
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  computed: {
    noMore() {
      return (
        this.contentParams.page * this.contentParams.size >
        this.contentInfoListTotal
      );
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    getImageURL(cover) {
      return getImageURL(cover);
    },
    getInfoClass() {
      request.getDicts().then((res) => {
        this.InfoObject = res.data.filter((item) => item.value === "视频")[0];
        this.getItemList();
      });
    },
    getCategoriesPoster() {
      request
        .getCategoriesPosters({
          id: this.contentParams.categoryId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.advertisementsList = res.data;
          }
        });
    },
    getCategoriesLabels() {
      request
        .getCategoriesLabels({
          id: this.contentParams.categoryId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.labelList = res.data;
          }
        });
    },
    getItemList() {
      request.getCategoriesByType(this.InfoObject.code).then((res) => {
        this.itemList = res.data;
        this.itemList.length > 0 &&
          (this.contentParams.categoryId = this.itemList[0].id);
        this.getContentInfo();
        this.getCategoriesPoster();
        this.getCategoriesLabels();
      });
    },
    getContentInfo() {
      request.getResourceVideos(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    changeParams(val) {
      this.contentParams = {
        categoryId: val,
        page: 1,
        size: 10,
      };
      this.contentParams.categoryId = val;
      this.contentInfoList = [];
      this.getContentInfo();
      this.getCategoriesPoster();
      this.getCategoriesLabels();
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.contentParams.page += 1;
        this.getContentInfo();
        this.loading = false;
      }, 2000);
    },
    handleDetail(id, type) {
      this.$router.push({ path: `/video/player/${id}?type=${type}` });
    },
    handleTopic(val) {
      request
        .getTopics({
          topic: val,
        })
        .then((res) => {
          if (res.data) {
            this.$router.push({
              path: `/account?topic=${val}`,
            });
          } else {
            this.$router.push({
              path: `/search?content=${val}`,
            });
          }
        });
    },
    gotoURL(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="less">
.video {
  .categoryContent {
    // height: 32rem;
    width: 100%;
    overflow-y: scroll;
    list-style: none;
    padding: 0px;
    .categoryDiv {
      padding: 8px;
      // position: relative;
      display: flex;
      .title {
        font-size: 0.7rem;
        padding: 8px 0rem;
        position: absolute;
        left: 1rem;
        color: #fff;
        width: 90%;
      }
    }
  }
  .tagDiv {
    margin-top: 10px;
    padding: 10px;
    height: 50px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    // ::-webkit-scrollbar:;
    .tagLabel {
      background: rgba(153, 153, 153, 1);
      color: #fff;
      border-radius: 20px;
      font-size: 14px;
      padding: 5px 10px;
      margin: 0px 5px;
    }
  }
}
</style>

